import { 
    FETCH_SETTINGS_REQUEST,
    RECEIVE_PUBLIC_SETTINGS,
    RECEIVE_PRIVATE_SETTINGS, 
    RECEIVE_SETTINGS_KO 
} from '../../../constants/index'
import { Settings } from '../types/settings';

export function receivePublicSettings(settings: Settings) {
    return {
        type: RECEIVE_PUBLIC_SETTINGS,
        payload: {
            data: settings
        },
    };
}

export function receivePrivateSettings(settings: Settings) {
    return {
        type: RECEIVE_PRIVATE_SETTINGS,
        payload: {
            data: settings
        },
    };
}

// TODO
// export function receiveSettingsError(error) {
//     return {
//         type: RECEIVE_SETTINGS_KO,
//         payload: {
//             data,
//         },
//     };
// }

export function fetchSettingsRequest() {
    return {
        type: FETCH_SETTINGS_REQUEST,
    };
}